import FJConfig from "../config/FJConfig";
import FJNetworkStore from "./FJNetworkStore";

export default (function () {

  let _decorationOverlays = [];
  let _decorationDataStore = {};
  return {
    init: async function () {
      let listPath = FJConfig.decorationOverlayPath + '/list.json?v=' + FJConfig.version;
      let list = await FJNetworkStore.fetchResourceAsync(listPath);
      if (list) {
        _decorationOverlays = list;
      } else {
        throw new Error('fetch overlay list failed');
      }
    },
    allOverlays: function () {
      return _decorationOverlays;
    },
    getDecorationData: async function (decorationName) {
      let {decorationOverlayPath, version} = FJConfig;

      // 资源数据里 arrow-up 的 name 字段是 3，所以这里进行兼容处理
      const name = decorationName === "3" ? "arrow-up" : decorationName;

      if (!_decorationDataStore[name]) {
        _decorationDataStore[name] = await FJNetworkStore.fetchResourceAsync(`${decorationOverlayPath}/${name.toLowerCase()}/info.json?v=${version}`);
      }
      return _decorationDataStore[name];
    },
  }
})();